export const brandedJobs: Record<string, any> = {
  '11111111': {
    advertiser: {
      id: '24740402',
      name: 'Envato',
    },
    classification: {
      id: '6281',
      description: 'Information & Communication Technology',
    },
    subClassification: {
      id: '6302',
      description: 'Web Development & Production',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Job with branding',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    listingDate: {
      label: '1d ago',
      dateTimeUtc: '2022-09-21T00:00:00Z',
    },
    workType: 'Full Time',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/nrJtHemSPW4?rel=0',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/envato-438862/reviews?jobId=29800267',
      fullName: 'Envato',
    },
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [],
    branding: {
      id: '5d4c53e2-fce4-4f03-b42c-f28f4afd2d68',
      cover: {
        url: 'https://image-service-cdn.seek.com.au/8998c42874b5fc37ade3c4835d90a6e8b4a15594/c8b25522df6ae64b702de8b835458b5978fa4206',
      },
      thumbnailCover: {
        url: 'https://image-service-cdn.seek.com.au/8998c42874b5fc37ade3c4835d90a6e8b4a15594/0896a62b69be2bc9b6cce34f46b0fbe70ab098df',
      },
      logo: {
        url: 'https://image-service-cdn.seek.com.au/58dc4d1dcf3db6dd93d424a88a7b8b09f7c8ff43/f3c5292cec0e05e4272d9bf9146f390d366481d0',
      },
    },
    gfjInfo: {
      location: {
        countryCode: 'AU',
        country: 'Australia',
        suburb: 'Melbourne',
        region: '',
        state: 'Victoria',
        postcode: '3000',
      },
      workTypes: {
        label: ['FULL_TIME'],
      },
    },
    seoInfo: {
      normalisedRoleTitle: 'job with branding',
      workType: '242',
      classification: ['6281', '6008'],
      subClassification: ['6302', '6015'],
      where: 'Melbourne VIC 3004',
    },
  },
  '22222222': {
    advertiser: {
      id: '24740402',
      name: 'Envato',
    },
    classification: {
      id: '6281',
      description: 'Information & Communication Technology',
    },
    subClassification: {
      id: '6302',
      description: 'Web Development & Production',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Job with branding',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    listingDate: {
      label: '2d ago',
      dateTimeUtc: '2022-09-21T00:00:00Z',
    },
    workType: 'Full Time',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/nrJtHemSPW4?rel=0',
      position: 'TOP',
    },
    companyProfile: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [],
    branding: {
      id: '5d4c53e2-fce4-4f03-b42c-f28f4afd2d68',
      cover: {
        url: 'https://image-service-cdn.seek.com.au/8998c42874b5fc37ade3c4835d90a6e8b4a15594/c8b25522df6ae64b702de8b835458b5978fa4206',
      },
      thumbnailCover: {
        url: 'https://image-service-cdn.seek.com.au/8998c42874b5fc37ade3c4835d90a6e8b4a15594/0896a62b69be2bc9b6cce34f46b0fbe70ab098df',
      },
      logo: {
        url: 'https://image-service-cdn.seek.com.au/58dc4d1dcf3db6dd93d424a88a7b8b09f7c8ff43/f3c5292cec0e05e4272d9bf9146f390d366481d0',
      },
    },
    gfjInfo: {
      location: {
        countryCode: 'AU',
        country: 'Australia',
        suburb: 'Melbourne',
        region: '',
        state: 'Victoria',
        postcode: '3000',
      },
      workTypes: {
        label: ['FULL_TIME'],
      },
    },
    seoInfo: {
      normalisedRoleTitle: 'job with branding',
      workType: '242',
      classification: ['6281', '6008'],
      subClassification: ['6302', '6015'],
      where: 'Melbourne VIC 3004',
    },
  },
  '33333333': {
    advertiser: {
      id: '24740402',
      name: 'Envato',
    },
    classification: {
      id: '6281',
      description: 'Information & Communication Technology',
    },
    subClassification: {
      id: '6302',
      description: 'Web Development & Production',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Job with logo-only branding',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    listingDate: '50m ago',
    workType: 'Full Time',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/nrJtHemSPW4?rel=0',
      position: 'TOP',
    },
    companyProfile: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [],
    branding: {
      id: '5d4c53e2-fce4-4f03-b42c-f28f4afd2d68',
      cover: null,
      logo: {
        url: 'https://image-service-cdn.seek.com.au/58dc4d1dcf3db6dd93d424a88a7b8b09f7c8ff43/f3c5292cec0e05e4272d9bf9146f390d366481d0',
      },
    },
    gfjInfo: {
      location: {
        countryCode: 'AU',
        country: 'Australia',
        suburb: 'Melbourne',
        region: '',
        state: 'Victoria',
        postcode: '3000',
      },
      workTypes: {
        label: ['FULL_TIME'],
      },
    },
    seoInfo: {
      normalisedRoleTitle: 'job with logo-only branding',
      workType: '242',
      classification: ['6281', '6008'],
      subClassification: ['6302', '6015'],
      where: 'Melbourne VIC 3004',
    },
  },
};
